<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>an toàn sản phẩm<!--製品的安全性--></h1>
        </div>
      </header>
      <HeaderNav activeLink="manufacturing" />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Tóm tắt an toàn của sản phẩm Fudizi<!--富地滋製品的安全性概要--></h2>
            <p>
              Các loại thực phẩm chính như "Fudizi DN Collagen" phải trải qua các cuộc kiểm tra độc tính thường xuyên và kiểm tra năng lượng phóng xạ để xác nhận sự an toàn của chúng.
              <!--關於「富地滋DN膠原」等主要食品皆會定期進行毒性試驗、放射能檢查以確認其安全性。-->
              <br />
              Dòng sản phẩm chăm sóc da trải qua quá trình kiểm tra da và kiểm tra dị ứng.
              <!--保養品系列產品則是進行貼膚測試與過敏測試。-->
            </p>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Collagen Fudizhi DN<!--富地滋DN膠原--></h2>
            <table class="manufactoring-table">
              <tr>
                <th class="td-bg-dark" colspan="2">Dự án thử nghiệm: Thử nghiệm độc tính<!--試驗項目：毒性試驗--></th>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  Thử nghiệm độc tính qua đường miệng (chuột)
                  <!--單次口服毒性試驗(大白鼠)-->
                </th>
              </tr>
              <tr>
                <th>Bài kiểm tra ‧ cơ quan kiểm tra<!--試驗 ‧ 檢查機關--></th>
                <td>
                  (Quỹ hợp nhất chung) Trung tâm An toàn Thực phẩm và Dược phẩm
                  <!--(一般財團法人)食品藥品安全中心-->
                </td>
              </tr>
              <tr>
                <th>hướng dẫn ‧ Tóm tắt các phương pháp thử nghiệm<!--指導準則 ‧ 試驗法概要--></th>
                <td>
                  Hướng dẫn kiểm tra độc tính của sản phẩm dược phẩm
                  <!--醫藥品毒性試驗法準則--> 
                  <br />
                  〔1〕Xét nghiệm độc tính qua đường miệng một lần (Khai thuốc lần 1 số 24 ngày 11/9/2011, Thuốc mới số 88 ngày 10/8/2005)
                  <!--〔1〕單次口服毒性測試(平成元年9月11日 藥審1第24號、平成5年8月10日藥新藥第88號)-->
                </td>
              </tr>
              <tr>
                <th>Tóm tắt kết quả<!--結果概要--></th>
                <td>
                  LD50&gt;20ml/kg <br />
                  Không có trường hợp tử vong, bất thường về tình trạng chung hoặc bất thường về trọng lượng cơ thể. Dựa trên giải phẫu bệnh lý, 
                  không có bất thường nên không có dấu hiệu ngộ độc cấp tính.
                  <!--無死亡例、一般狀態的異常、體重異常的情況發生，根據病理解剖並判斷無異常，因此無顯示急性毒性。-->
                </td>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  Thử nghiệm độc tính qua đường miệng lặp lại trong 28 ngày (chuột)
                  <!--28天反覆口服毒性試驗(大白鼠)-->
                </th>
              </tr>
              <tr>
                <th>Bài kiểm tra ‧ cơ quan kiểm tra<!--試驗 ‧ 檢查機關--></th>
                <td>
                  (Quỹ hợp nhất chung) Trung tâm An toàn Thực phẩm và Dược phẩm
                  <!--(一般財團法人)食品藥品安全中心-->
                </td>
              </tr>
              <tr>
                <th>hướng dẫn ‧ Tóm tắt các phương pháp thử nghiệm<!--指導準則 ‧ 試驗法概要--></th>
                <td>
                  "Hướng dẫn sửa đổi về tiêu chuẩn chỉ định và sử dụng phụ gia thực phẩm" (Weihua số 29, ngày 22 tháng 3 năm 2008)
                  <!--「關於食品添加物的指定及使用基準改正方針」(平成8年3月22日 衛化第29號)-->
                </td>
              </tr>
              <tr>
                <th>Tóm tắt kết quả<!--結果概要--></th>
                <td>
                  NOAEL&gt;10ml/kg/ngày<!--日-->
                  <br />
                  Không có trường hợp tử vong, bất thường về tình trạng chung, hoặc bất thường về trọng lượng cơ thể. Dựa trên các xét nghiệm máu, 
                  xét nghiệm bệnh lý và mô học, v.v., xác định rằng không có bất thường nên không có độc tính.
                  <!--無死亡例、一般狀態的異常、體重異常的情況發生，根據血液學檢查、病理組織學的檢查等並判斷無異常，因此無毒性。-->
                </td>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  Kiểm tra đột biến ngược (kiểm tra Ames/phương pháp kiểm tra Ames)
                  <!--回復突變試驗(Ames test /安姆氏測試法)-->
                </th>
              </tr>
              <tr>
                <th>Bài kiểm tra ‧ cơ quan kiểm tra<!--試驗 ‧ 檢查機關--></th>
                <td>
                  (Quỹ hợp nhất chung) Trung tâm An toàn Thực phẩm và Dược phẩm
                  <!--(一般財團法人)食品藥品安全中心-->
                </td>
              </tr>
              <tr>
                <th>hướng dẫn ‧ Tóm tắt các phương pháp thử nghiệm<!--指導準則 ‧ 試驗法概要--></th>
                <td>
                  "Hướng dẫn kiểm tra độc tính gen của dược phẩm và các diễn giải liên quan" (Số 0920 Tạp chí Dược phẩm và Thực phẩm, ngày 20 tháng 9 năm 2014) 
                  "Hướng dẫn của OECD về Phương pháp Kiểm tra Chất Hóa học 471, Thử nghiệm Đột biến Ngược bằng Vi khuẩn" (OECDTG471, ngày 21 tháng 7 năm 1997 )
                  <!--「關於醫藥品的遺傳毒性測試及相關解釋之指導」(平成24年9月20日 藥食審查發0920第2號)「OECD化學物質測試法指導準則471、使用細菌的回復突變試驗」(OECDTG471、1997年7月21日)-->
                </td>
              </tr>
              <tr>
                <th>Tóm tắt kết quả<!--結果概要--></th>
                <td>Âm tính (không gây đột biến gen)<!--陰性(沒有基因突變誘因)--></td>
              </tr>
            </table>
            <p>
              "Đối tượng thử nghiệm: Sản phẩm sản xuất tháng 5 năm 2018 (thế hệ thứ 8)"
              <!--『被試驗物：2018年5月製造品(第八世代)』-->
            </p>
            <p>
              Công ty chúng tôi luôn cam kết thiết lập hệ thống quản lý chất lượng và đảm bảo an toàn cho sản phẩm của mình. Sau trận động đất lớn ở phía Đông Nhật Bản, 
              để mang đến cho khách hàng sự an toàn và bảo mật cao hơn, chúng tôi sẽ tiến hành xác minh chất phóng xạ tại các địa điểm cung cấp nguyên liệu 
              thô và báo cáo kết quả cho bạn.
              <!--敝公司平時致力於確立品質管理體制及確保製品的安全性。東日本大震災發生後，為了提供客人更多的安全及安心，我們會於原材料供給的地方進行放射性物質的確認並將其結果報告給各位。-->
            </p>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Túi xách tay Fortune Zi LOHAS<!--富地滋樂活隨身包--></h2>
            <table class="manufactoring-table">
              <tr>
                <th class="td-bg-dark" colspan="2">Dự án thử nghiệm: Thử nghiệm độc tính<!--試驗項目：毒性試驗--></th>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  Thử nghiệm độc tính qua đường miệng (chuột)
                  <!--單次口服毒性試驗(大白鼠)-->
                </th>
              </tr>
              <tr>
                <th>Bài kiểm tra ‧ cơ quan kiểm tra<!--試驗 ‧ 檢查機關--></th>
                <td>
                  (Quỹ hợp nhất chung) Trung tâm An toàn Thực phẩm và Dược phẩm
                  <!--(一般財團法人)食品藥品安全中心-->
                </td>
              </tr>
              <tr>
                <th>hướng dẫn ‧ Tóm tắt các phương pháp thử nghiệm<!--指導準則 ‧ 試驗法概要--></th>
                <td>
                  Hướng dẫn kiểm tra độc tính của sản phẩm dược phẩm
                  <!--醫藥品毒性試驗法準則-->
                   <br />
                  〔1〕Thử nghiệm độc tính qua đường miệng
                  <!--〔1〕單次口服毒性測試--> 
                  <br />
                  (Kiểm tra ma túy lần 1 số 24 ngày 11/9/2001 và Kiểm tra ma túy số 88 ngày 10/8/2005)
                  <!--(平成元年9月11日 藥審1第24號、平成5年8月10日、藥新藥第88號)-->
                </td>
              </tr>
              <tr>
                <th>Tóm tắt kết quả<!--結果概要--></th>
                <td>
                  LD50&gt;2000mg/kg
                  <br />
                  Không có trường hợp tử vong, bất thường về tình trạng chung hoặc bất thường về trọng lượng cơ thể. Dựa trên giải phẫu bệnh lý, 
                  không có bất thường nên không có dấu hiệu ngộ độc cấp tính.
                  <!--無死亡例、一般狀態的異常、體重異常的情況發生，根據病理解剖並判斷無異常，因此無顯示急性毒性。-->
                </td>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  Thử nghiệm độc tính qua đường miệng lặp lại trong 28 ngày (chuột trắng)
                  <!--28 天反覆進行口服毒性測試(白老鼠)-->
                </th>
              </tr>
              <th>Bài kiểm tra ‧ cơ quan kiểm tra<!--試驗 ‧ 檢查機關--></th>
                <td>
                  (Quỹ hợp nhất chung) Trung tâm An toàn Thực phẩm và Dược phẩm
                  <!--(一般財團法人)食品藥品安全中心-->
                </td>
              <tr>
                <th>hướng dẫn ‧ Tóm tắt các phương pháp thử nghiệm<!--指導準則 ‧ 試驗法概要--></th>
                <td>
                  "Chính sách cải cách về chỉ định và tiêu chuẩn sử dụng phụ gia thực phẩm" (Weihua số 29, ngày 22 tháng 3 năm 2008)
                  <!--「關於食品添加物的指定及使用基準改政方針」(平成8年3月22日衛化第29號)-->
                </td>
              </tr>
              <tr>
                <th>Tóm tắt kết quả<!--結果概要--></th>
                <td>
                  NOAEL &gt; 1000mg/kg/ngày<!--日-->
                  <br />
                  Không có trường hợp tử vong và không có độc tính nào được đánh giá.
                  <!--無死亡，判斷無毒性。-->
                </td>
              </tr>
            </table>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/SafetyHeaderNav";
export default {
  name: "ManufacturingScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 767px) {
  .public-page
    .manufactoring-table
    th:not(.td-bg-middle-dark):not(.td-bg-dark) {
    width: 120px;
  }
}
</style>
